import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import useCountdown from '../hooks/useCountdown';
import { retryAfterSeconds, formatCountdown } from '../utils/retryAfter';
import './Login.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [lockLeft, startLock] = useCountdown();
  const locked = lockLeft > 0;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authAPI.forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      if (err.response?.status === 429) {
        startLock(retryAfterSeconds(err));
      } else {
        setError(err.response?.data?.error || 'Something went wrong. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Outreach Engine</h1>
          <p>Reset your password</p>
        </div>

        {submitted ? (
          <div>
            <div className="success-message">
              If that email is registered, you'll receive a reset link shortly. Check your inbox.
            </div>
            <div className="auth-footer" style={{ marginTop: '24px' }}>
              <Link to="/login" className="auth-link">Back to sign in</Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            {locked && (
              <div className="error-message throttle-message" role="status">
                Too many attempts. Try again in {formatCountdown(lockLeft)}.
              </div>
            )}
            {error && <div className="error-message">{error}</div>}

            <p style={{ color: 'var(--text-secondary)', fontSize: '14px', margin: '0' }}>
              Enter your email address and we'll send you a link to reset your password.
            </p>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                placeholder="Enter your email"
                disabled={loading}
              />
            </div>

            <button type="submit" className="login-button" disabled={loading || locked}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <div className="auth-footer" style={{ marginTop: '0' }}>
              <Link to="/login" className="auth-link">Back to sign in</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
